"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    KEYBOARD_NAV_ATTRIBUTE: ()=>KEYBOARD_NAV_ATTRIBUTE,
    KEYBOARD_NAV_SELECTOR: ()=>KEYBOARD_NAV_SELECTOR,
    FOCUS_VISIBLE_ATTR: ()=>FOCUS_VISIBLE_ATTR,
    FOCUS_WITHIN_ATTR: ()=>FOCUS_WITHIN_ATTR,
    defaultOptions: ()=>defaultOptions
});
const KEYBOARD_NAV_ATTRIBUTE = 'data-keyboard-nav';
const KEYBOARD_NAV_SELECTOR = `:global([${KEYBOARD_NAV_ATTRIBUTE}])`;
const FOCUS_VISIBLE_ATTR = 'data-fui-focus-visible';
const FOCUS_WITHIN_ATTR = 'data-fui-focus-within';
const defaultOptions = {
    style: {},
    selector: 'focus'
}; //# sourceMappingURL=constants.js.map

//# sourceMappingURL=constants.js.map